import React from 'react';

export default function ColorSwatch({
  label,
  value = '#000000',
  onChange,
  allowTransparent = false,
  size = 28
}) {
  const displayValue = value || '#000000';

  return (
    <div className="color-swatch-row">
      {label && <label className="color-swatch-label">{label}</label>}

      <div className="color-swatch-control">
        <input
          type="color"
          value={displayValue}
          onChange={(e) => onChange(e.target.value)}
          className="color-swatch-input"
          style={{
            width: size,
            height: size
          }}
        />

        {allowTransparent && (
          <button
            type="button"
            className="btn btn-sm btn-light"
            onClick={() => onChange(null)}
          >
            Transparent
          </button>
        )}
      </div>
    </div>
  );
}
